module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Kevin Belton's New Orleans Celebrations")]), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Acknowledgments ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("Introduction ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The French Quarter ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Mac Fingers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Green Tomatoes "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Lemon Aioli\n        ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bananas Foster Bread Pudding "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Rum Sauce\n        ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jazzy Fest Food ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buffalo Chicken Dip Stuffed Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Rémoulade Po’ Boy ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e552",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Louisiana Seafood Pasta ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Que Up The BBQ ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e623",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham Croquettes "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Peach-Pepper Dipping\n            Sauce ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e682",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pulled Pork and Slaw Sandwiches ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e759",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asian Beef Skewers ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Oyster Fest ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e822",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Oysters ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e872",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oyster Chowder ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e918",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oyster Tamales "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Red Chile Sauce\n        ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creole Tomato ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Pie ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margherita Crêpes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Tomatoes "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Gulf Tuna Salad\n        ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gumbo ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#gumbob",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gumbo Base ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Okra Gumbo ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gumbo Z’herbes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Filé Gumbo Lasagna ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crawfish ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e1371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crawfish Enchiladas "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("Con Queso\n        ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e1419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crawfish-Stuffed Mushrooms ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e1473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crawfish Balls ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boudin ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#hboudin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Boudin ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1605",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Boudin Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1646",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boudin Wraps ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e1666",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boudin Pizza ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sweet Strawberry ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e1732",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rib-eye Steak Salad "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Strawberry Balsamic\n            Vinaigrette ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e1787",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Waffle Bowls "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Chocolate-Dipped\n            Strawberries ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e1840",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Icebox Pie ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flavorful Catfish ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e1911",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato Chip-Crusted Catfish Nuggets "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with\n            Creole Mayonnaise ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e1970",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catfish Tacos "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Chimichurri Sauce\n        ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e2044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Catfish Dip ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hand Pie ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natchitoches Meat Pies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crawfish Pies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e2252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit Hand Pies ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jammin’ on Jambalaya ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e2341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastalaya ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e2387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast Jambalaya ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e2447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jambalaya-Stuffed Chicken Thighs ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e2529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Rice Au Gratin ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e2569",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli Fried Rice ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e2617",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon and Egg Calas ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greek Heritage ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e2686",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greek Lentil Salad ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e2745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Shrimp Gyros "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Herbed Yogurt\n            Spread ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e2804",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolmades ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Louisiana Blue Crab ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#d0e2877",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab Ravigote ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#d0e2914",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creole Crab Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#d0e2976",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab Claws "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Marinara Sauce\n        ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Étouffée ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#d0e3055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom and Steak Étouffée "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Cheesy\n            Mashed Potato Patties ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#d0e3158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork and Onion Étouffée ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#d0e3213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gulf Fish Étouffée ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bastille Day ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#d0e3293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Liver Pâté ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#d0e3329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crustless Spinach and Leek Quiche ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#d0e3369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stone Fruit Galette ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Chicken ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#d0e3469",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Heat Pan-Fried Chicken ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#d0e3523",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Salad Sliders ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#d0e3565",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken and Waffle Melt ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oktoberfest ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#d0e3686",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Sausage "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Cajun Poutine\n        ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#d0e3752",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Schnitzel "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Bacon-Apple Sauerkraut\n        ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#d0e3823",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laugenbrezel "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("(Traditional German Pretzels)\n            with Beer-Cheese Sauce ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Powdery Beignet ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#bdough",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beignets "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Chocolate Sauce\n        ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#d0e3970",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lobster Beignets ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#d0e4021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbed Ham and Cheese Beignets ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Orleans Neighborhoods ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#d0e4075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesesteak Po’ Boy ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#d0e4119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Velvet Funnel Cakes "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Cream Cheese\n            Drizzle ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#d0e4184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parmesan-Garlic Chicken Wings "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("and Greens\n        ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#d0e4284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Nachos ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#d0e4336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp and Grits ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#d0e4405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Batter Shrimp Fritters ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Orleans Italian—The Sicilian Way ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25#d0e4472",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Calamari "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Creamy Lemon Butter\n            Sauce ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25#d0e4529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sausage and Pepper Calzone ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25#d0e4577",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meatball Po’ Boy "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("with Vodka Sauce\n        ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cajun Cooking Culture ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26#d0e4683",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cajun Fried Frog Legs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26#d0e4731",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catfish Courtbouillon ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26#d0e4792",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cracklins ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celebrating Latin Influence ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27#d0e4837",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patatas Bravas "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("With Garlic Aioli\n        ")])])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27#d0e4896",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Empanadas ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27#d0e4960",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cemita Poblana "), _c('span', {
    staticClass: "h1sub"
  }, [_vm._v("(Puebla-Style Sandwich)\n        ")])])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Orleans Burger ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28#d0e5025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon Monster Burger ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28#d0e5121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp and Crab Burger ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28#d0e5171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triple Cheesy Cheese Burger ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425e16fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01toc.vue
// module id = 63
// module chunks = 0